import React from 'react';
import { ModernButton } from '../../ui/modern';

const FIELD_TYPES = [
  { type: 'text', label: 'Text', icon: '🔤' },
  { type: 'email', label: 'Email', icon: '📧' },
  { type: 'number', label: 'Number', icon: '🔢' },
  { type: 'password', label: 'Password', icon: '🔒' },
  { type: 'textarea', label: 'Textarea', icon: '📝' },
  { type: 'select', label: 'Select', icon: '⬇️' },
  { type: 'multiselect', label: 'Multi-select', icon: '✅' },
  { type: 'radio', label: 'Radio', icon: '🔘' },
  { type: 'checkbox', label: 'Checkbox', icon: '☑️' },
  { type: 'date', label: 'Date', icon: '📅' },
  { type: 'file', label: 'File', icon: '📎' },
];

export default function FieldPalette({ onAddField }) {
  return (
    <div className="space-y-3">
      <div className="text-sm font-semibold text-gray-700 dark:text-slate-300">Field Palette</div>
      <div className="grid grid-cols-1 gap-2">
        {FIELD_TYPES.map((f) => (
          <ModernButton
            key={f.type}
            variant="glass"
            className="justify-start"
            onClick={() => onAddField(f.type)}
          >
            <span className="mr-2">{f.icon}</span>
            {f.label}
          </ModernButton>
        ))}
      </div>
    </div>
  );
}


